module.exports = __webpack_public_path__ + "img/1497938925.b999ad63.jpg";